"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _react = _interopRequireDefault(require("react"));
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _WaterGoingModal = _interopRequireDefault(require("./WaterGoingModal"));
require("../styles/VsPumpSetupComponent.css");
var _Button = require("@ccw-pwa-ui/Button");
const EditWaterDestinationComponent = _ref => {
  let {
    headerText,
    pumpSetupContent,
    handleWaterModal,
    openWaterModal,
    aboutWaterContent,
    items,
    selectedItems,
    handleCheckBoxSelection,
    pumpSetupBottomContent,
    saveContinueBtnClick,
    saveContinueBtnTitle,
    saveContinueBtnDisabled,
    shouldCheckBoxDisabled,
    positiveActionButtonTitle,
    modalHeaderText,
    learnMoreText,
    imageData,
    handleBack,
    leftArrow,
    backNavigationScreen,
    renderBackBtn,
    modelNumber
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pump-setup-body"
  }, renderBackBtn && /*#__PURE__*/_react.default.createElement("div", {
    className: "pump-setup-dashboard-navigate",
    onClick: handleBack,
    "data-testid": "handleEditBack"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
    src: leftArrow
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "pump-setup-content"
  }, backNavigationScreen)), /*#__PURE__*/_react.default.createElement("div", {
    className: "pump-setup-main-heading"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "pump-setup-subContent"
  }, /*#__PURE__*/_react.default.createElement("p", null, pumpSetupContent)), /*#__PURE__*/_react.default.createElement("div", {
    className: "model-number-label"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: modelNumber
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "pump-setup-water-content",
    "data-testid": "pump-setup-water-content",
    onClick: () => handleWaterModal(!openWaterModal)
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
    className: "pump-setup-modalImg",
    src: _index.default.questionIcon.default
  })), aboutWaterContent), /*#__PURE__*/_react.default.createElement("div", {
    className: "pump-system-btn-wrapper",
    "data-testid": "pump-system-btn-wrapper"
  }, items === null || items === void 0 ? void 0 : items.map((item, index) => /*#__PURE__*/_react.default.createElement("label", {
    key: item.name,
    "data-testid": "pump-system-input",
    className: "myLabel ".concat(selectedItems[item.name] ? "checkedItem" : "")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "custom ".concat(selectedItems[item.name] ? "checkedItem" : "")
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "right-tick-image",
    src: _index.default.rightTick.default,
    alt: ""
  })), /*#__PURE__*/_react.default.createElement("input", {
    className: "myInput",
    type: "checkbox",
    checked: selectedItems[item.name],
    onChange: e => handleCheckBoxSelection(item.name, e.target.checked),
    disabled: shouldCheckBoxDisabled && !selectedItems[item.name]
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "label-name"
  }, item.name), /*#__PURE__*/_react.default.createElement("span", {
    className: "label-image"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: item.image,
    alt: item.name
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "pump-setup-bottom-content"
  }, /*#__PURE__*/_react.default.createElement("p", null, pumpSetupBottomContent)), /*#__PURE__*/_react.default.createElement("div", {
    className: "pump-setup-update-btn",
    "data-testid": "pump-setup-update-btn"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: saveContinueBtnTitle,
    onClick: () => saveContinueBtnClick(),
    disabled: saveContinueBtnDisabled
  })), openWaterModal ? /*#__PURE__*/_react.default.createElement(_WaterGoingModal.default, {
    openWaterModal: openWaterModal,
    positiveActionButtonTitle: positiveActionButtonTitle,
    modalHeaderText: modalHeaderText,
    learnMoreText: learnMoreText,
    handleWaterModal: handleWaterModal,
    imageData: imageData
  }) : "");
};
var _default = exports.default = EditWaterDestinationComponent;